"use client";

import type { FC } from "react";

import { HoReCaLocator as UIHoReCaLocator } from "@des/locators/components/HoReCaLocator";

import type { horecaLocatorInputs } from "./HoReCaLocator.builder";

type HoReCaLocatorBuilderProps = BuilderComponentProps<typeof horecaLocatorInputs>;

const DEFAULT_ZOOM = 15;

export const HoReCaLocator: FC<HoReCaLocatorBuilderProps> = ({
  defaultLatitude,
  defaultLongitude,
  storesLimit,
  defaultZoom,
}) => {
  return (
    <UIHoReCaLocator
      defaultLat={String(defaultLatitude)}
      defaultLng={String(defaultLongitude)}
      defaultZoom={defaultZoom || DEFAULT_ZOOM}
      storesLimit={storesLimit || 1000}
    />
  );
};
